import React from "react";
import PropTypes from "prop-types";
import ListingHeader from "@brand/ListingHeader/ListingHeader";
import { connect } from "react-redux";
import { getListingHeaderMerchandisings } from "app/pages/Merchandising/merchandisingSelector";
import {
	getTopDestinationFilterValues,
	getVisibleProducts,
} from "app/pages/Listing/productsSelector";
import find from "lodash/find";
import { bindActionCreators } from "redux";
import { setListingFilterStickness } from "app/pages/Header/menuActionCreators";
import { shouldFetchNavlogs } from "app/pages/Listing/NavLogs/navLogsSelector";

const ListingHeaderContainer = props => <ListingHeader {...props} />;

ListingHeaderContainer.propTypes = {
	idSpotlight: PropTypes.number,
	isListViewDisplay: PropTypes.bool,
	scrollToListingHeader: PropTypes.func,
	toogleCardView: PropTypes.func,
	toogleListView: PropTypes.func,
};

const mapStateToProps = (state, props) => {
	const products = getVisibleProducts(state);
	const idSpotlight = props.idSpotlight;
	const topDestinationsFilterValues = getTopDestinationFilterValues(state);
	return {
		resolution: state.resolution,
		heroProduct: find(getVisibleProducts(state), product => {
			return product.uri && product.uri === idSpotlight;
		}),
		activeFilters: state.productsFilters,
		topDestinationsFilterValues: topDestinationsFilterValues,
		merchandisingHeader: getListingHeaderMerchandisings(state, idSpotlight).merchList,
		products,
		brand: state.brand.code,
		partnerCode: state.partner.code,
		enableAtol: state.shop.slice(3, 5) === "GB",
		shouldFetchNavlogs: shouldFetchNavlogs(state),
		marketingBanner: state.partner.marketingBanner,
	};
};

const mapDispatchToProps = dispatch => {
	return bindActionCreators(
		{
			setListingFilterStickness,
		},
		dispatch
	);
};

export default connect(
	mapStateToProps,
	mapDispatchToProps
)(ListingHeaderContainer);
